import { render } from "./AdminAbstract.vue?vue&type=template&id=71849cec"
import script from "./AdminAbstract.vue?vue&type=script&lang=js"
export * from "./AdminAbstract.vue?vue&type=script&lang=js"

import "./AdminAbstract.vue?vue&type=style&index=0&id=71849cec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__